import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../feature-module/router/all_routes";

const FieldConfigurationSidebar: React.FC = () => {
  const location = useLocation();
  const route = all_routes;

  const [openSection, setOpenSection] = useState<string>("customFields");

  useEffect(() => {
    if (
      location.pathname === route.lifecycleStatusReasonLost ||
      location.pathname === route.lifecycleStatusReasonWon
    ) {
      setOpenSection("lifecycle");
    } else if (location.pathname === route.sourceSettings) {
      setOpenSection("source");
    } else {
      setOpenSection("customFields");
    }
  }, [location.pathname]);

  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? "" : section);
  };

  return (
    <div className="col-xl-3 col-lg-12 theiaStickySidebar">
      {/* Custom Fields */}
      <div className={`card mb-3 ${location.pathname === route.customFields ? "border-primary" : ""}`}>
        <Link to={route.customFields} className="card-body p-3 text-decoration-none d-block">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <i className={`ti ti-forms ${location.pathname === route.customFields ? "text-primary" : "text-gray"}`}></i>
              <h4 className={`fw-semibold mb-0 ${location.pathname === route.customFields ? "text-primary" : "text-dark"}`} style={{ fontSize: "16px" }}>Custom Fields</h4>
            </div>
          </div>
        </Link>
      </div>

      {/* Source Configuration */}
      <div className={`card mb-3 ${location.pathname === route.sourceSettings ? "border-primary" : ""}`}>
        <Link to={route.sourceSettings} className="card-body p-3 text-decoration-none d-block">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <i className={`fa fa-file-code ${location.pathname === route.sourceSettings ? "text-primary" : "text-gray"}`} />
              <h4 className={`fw-semibold mb-0 ${location.pathname === route.sourceSettings ? "text-primary" : "text-dark"}`} style={{ fontSize: "16px" }}>Source</h4>
            </div>
          </div>
        </Link>
      </div>

      {/* Activity Type */}
      <div className={`card mb-3 ${location.pathname === route.salesActivityType ? "border-primary" : ""}`}>
        <Link to={route.salesActivityType} className="card-body p-3 text-decoration-none d-block">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              <i className={`ti ti-clipboard-list ${location.pathname === route.salesActivityType ? "text-primary" : "text-gray"}`}></i>
              <h4 className={`fw-semibold mb-0 ${location.pathname === route.salesActivityType ? "text-primary" : "text-dark"}`} style={{ fontSize: "16px" }}>Activity Types</h4>
            </div>
          </div>
        </Link>
      </div>

      {/* Lifecycle Status Reason */}
      <div className="card mb-3">
        <div className="card-body p-3">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => toggleSection("lifecycle")}
          >
            <div className="d-flex align-items-center gap-2">
              <i className="ti ti-activity text-gray" />
              <h4 className="fw-semibold mb-0 text-dark" style={{ fontSize: "16px" }}>Lifecycle Status Reason</h4>
            </div>
            <i className={`ti ti-chevron-${openSection === "lifecycle" ? "up" : "down"}`}></i>
          </div>
          {openSection === "lifecycle" && (
            <div className="list-group list-group-flush settings-sidebar mt-3 border-top pt-3">
              <Link
                to={route.lifecycleStatusReasonLost}
                className={`fw-medium ${location.pathname === route.lifecycleStatusReasonLost ? "active" : ""
                  }`}
              >
                Lost Reasons
              </Link>
              <Link
                to={route.lifecycleStatusReasonWon}
                className={`fw-medium ${location.pathname === route.lifecycleStatusReasonWon ? "active" : ""
                  }`}
              >
                Won Reasons
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldConfigurationSidebar;
